import { render, staticRenderFns } from "./AdminProject.vue?vue&type=template&id=9b4aa220&"
import script from "./AdminProject.vue?vue&type=script&lang=js&"
export * from "./AdminProject.vue?vue&type=script&lang=js&"
import style0 from "./AdminProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports